export const getNumericEnumValues = <T extends Object>(enumObj: T): number[] => (
  Object
    .values(enumObj)
    .filter(v => !isNaN(Number(v)))
    .slice(0, Math.floor(Object.keys(enumObj).length / 2))
);
